export const SUCCESSFUL_SIGN_IN_MESSAGE = 'Successfully logged in';
export const SUCCESSFUL_SIGN_IN_VIA_GOOGLE_MESSAGE = 'Successfully logged in via Google';
export const SUCCESSFUL_SIGN_UP_MESSAGE =
  'Successfully created an account and logged in. Email address verification message was sent to your email';
export const SUCCESSFUL_LOGOUT_MESSAGE = 'Successfully logged out';
export const SUCCESSFUL_FORGOT_PASSWORD_MESSAGE = 'Check your inbox for further instructions';
export const SUCCESSFUL_RESET_PASSWORD_MESSAGE = 'Password has been change. Now you can login with a new one';
export const SUCCESSFUL_PROFILE_UPDATE_MESSAGE = 'Successfully update user profile data';
export const FAILED_PROFILE_UPDATE_MESSAGE = 'Failed to update user profile data';
export const SUCCESSFUL_PASSWORD_CHANGED_MESSAGE = 'Successfully changed password';
export const FAILED_PASSWORD_CHANGED_MESSAGE = 'Failed to changed password';
